import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home-1";  
import Login from "./pages/auth";  
import Blogs from './pages/Blogs';
import National from './pages/National';
import BlogDetail from './pages/BlogDetail'; 
import Author from './pages/Author';
import About from './pages/About';
import Contact from './pages/Contact';
import Loader from "./components/Loader";  
import AuthorList from "./pages/AuthorList"; 
import UserDetail from "./pages/userdetail"; 

const App = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  const isAuthPage = location.pathname === "/auth";

  return (
    <>
      {loading && <Loader />}  
      {!loading && (
        <>
          {!isAuthPage && <Header />}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/auth" element={<Login />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/national" element={<National />} />
            <Route path="/blogs/:id" element={<BlogDetail />} /> 
            <Route path="/author" element={<Author />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/authorlist" element={<AuthorList />} />          
            <Route path="/users/:id" element={<UserDetail />} /> 
          </Routes>
          {!isAuthPage && <Footer />}
        </>
      )}
    </>
  );
};

// Wrap the App component with Router
const AppWrapper = () => (
  <Router>
    <App />
  </Router>
);

export default AppWrapper;